import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/business";

export const FloatingWhatsApp = () => {
  return (
    <a
      href={waLink("السلام عليكم، أود الاستفسار عن خدمة صيانة المكيف")}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="تواصل عبر واتساب"
      data-testid="floating-whatsapp-button"
      className="fixed bottom-6 left-6 z-40 group"
    >
      <div className="relative">
        <span className="absolute inset-0 rounded-full whatsapp-pulse" />
        <div className="relative w-14 h-14 lg:w-16 lg:h-16 rounded-full bg-[#25D366] hover:bg-[#1DA851] flex items-center justify-center shadow-[0_8px_30px_rgba(37,211,102,0.4)] transition-all group-hover:scale-110">
          <MessageCircle className="w-6 h-6 lg:w-7 lg:h-7 text-white" />
        </div>
      </div>
      <span className="absolute bottom-full left-0 mb-2 whitespace-nowrap bg-slate-900 border border-slate-800 text-xs text-slate-200 px-3 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        تواصل فوري عبر واتساب
      </span>
    </a>
  );
};

export default FloatingWhatsApp;
